/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import { Tooltip, List, ListItemButton, ListItemText, ListItemIcon, Collapse, ToggleButtonGroup, ToggleButton } from '@mui/material'
import { ExpandLess, ExpandMore, AddBoxOutlined, ViewList, ViewModule, Sync } from '@mui/icons-material'
import { SideMenu } from './SideMenu'
import globalContext from '../../context/global/globalContext'
import { WtColor } from '../../constants/colours'
import { Container, Row, Col } from 'react-bootstrap'
import { WtLoader } from '../../controller/BaseTool'
import { TemplateButtonMessageForMultiPurpose, TemplateMessageWithVariable } from '../Chat/MessagesUI'
import { fetchChannelLsAPI } from '../../apis/APIs'
import { Link } from 'react-router-dom'

export const Templates = () => {
    const isLoading = useContext(globalContext)
    const handleWTLoader = useContext(globalContext)

    const channelLs = useContext(globalContext)
    const setChannelLs = useContext(globalContext)
    const getChannels = async () => {
        try {
            const response = await fetchChannelLsAPI()
            if (response.status === 200) {
                setChannelLs.setChannelLs(response.data.data)
                if (response.data.data.length !== 0) setChInfo(response.data.data[0].title, response.data.data[0].whatsapp)
                if (templateLs.templateLs?.length !== 0) getTemplatesUI.getTemplatesUI(response.data.data[0].whatsapp)
            }
        } catch (error) { }
    }
    useEffect(() => { getChannels() }, [])

    const [channelSwitch, setChannelSwitch] = useState(false)
    const handleChannelSwitch = () => { setChannelSwitch(!channelSwitch) }

    const [chName, setChName] = useState(undefined)
    const [chWhatsApp, setChWhatsApp] = useState(undefined)
    const setChInfo = (n, w) => {
        handleWTLoader.handleWTLoader(true)
        getTemplatesUI.getTemplatesUI(w)
        setChName(n)
        setChWhatsApp(w)
        setChannelSwitch(false)
    }

    const getTemplatesUI = useContext(globalContext)
    const templateLs = useContext(globalContext)
    const templateUIView = useContext(globalContext)
    const setTemplateUIView = useContext(globalContext)
    const setTemplateSync = useContext(globalContext)
    useEffect(() => {
        if (localStorage.getItem('c1') && templateLs.templateLs?.length === 0) {
            handleWTLoader.handleWTLoader(true)
            getTemplatesUI.getTemplatesUI(localStorage.getItem('c1'))
        }
    }, [])
    const handleTemplateSync = async () => await setTemplateSync.setTemplateSync(chWhatsApp)

    const handleTemplateUIView = (e, view) => {
        if (view === null) return
        setTemplateUIView.setTemplateUIView(view)
    }


    //Search
    const [searchLs, setSearchLs] = useState([])
    useEffect(() => { setSearchLs(templateLs.templateLs) }, [templateLs.templateLs])
    const searchItems = (searchValue) => {
        const filteredData = templateLs.templateLs.filter((item) => { return Object.values(item).join('').toLowerCase().includes(searchValue.toLowerCase()) })
        if (filteredData.length !== 0) {
            setSearchLs(filteredData)
        } else { setSearchLs([]) }
    }
    // End of Search

    const notificationBarStatus = useContext(globalContext)

    const mainStyle = { display: 'flex', backgroundColor: '#f8f8f8', height: notificationBarStatus.notificationBarStatus ? '85vh' : '95vh', width: '94vw' }
    const profile_menu_item = { flex: '0.85' }

    const chatBubbleNormal = { fontWeight: '400', fontSize: '14px', maxWidth: '300px', minWidth: '150px', overflowWrap: 'break-word', padding: '6px 10px', border: '1px solid ' + WtColor.LineColor, background: '#fff', borderRadius: '6px 6px 0px 6px', minHeight: '220px', maxHeight: 'auto' }
    const chatBubbleGrid = { fontWeight: '400', fontSize: '14px', maxWidth: '300px', minWidth: '150px', overflowWrap: 'break-word', padding: '6px 10px', border: '1px solid ' + WtColor.LineColor, background: '#fff', borderRadius: '6px 6px 0px 6px' }
    return (
        <div style={mainStyle}>
            <SideMenu />
            <div style={profile_menu_item} className="bg-white">
                <div>
                    <div className="border-bottom ps-3 pt-2 pb-1 pe-5" style={{ display: "flex" }}>
                        <div style={{ flex: 1, paddingTop: "4px" }}>
                            <h5 style={{ color: WtColor.TextDarkColor, fontSize: '16px' }}>Templates</h5>
                        </div>
                        <div>
                            <Link to={{ pathname: 'https://business.facebook.com/wa/manage/message-templates' }} target="_blank" className="btn btn-sm float-end me-4 ps-3 pe-3 fw-bold" style={{ border: '1px solid ' + WtColor.ProcessingBlue, color: WtColor.ProcessingBlue, background: "#fff", borderRadius: '8px' }}>Create Template</Link>
                        </div>
                    </div>
                    <div className="mt-2 ps-2">
                        <Container fluid>
                            <div className="mb-2 pb-2" style={{ borderBottom: '1px solid ' + WtColor.LineColor }}>
                                <Row>
                                    <Col>
                                        <div style={{ display: 'flex' }}>
                                            <List sx={{ flex: 1, width: '100%', maxWidth: 360, bgcolor: 'background.paper', paddingTop: "0px", paddingBottom: "0px" }} component="nav" aria-labelledby="nested-list-subheader">
                                                <ListItemButton onClick={handleChannelSwitch} style={{ border: '1px solid ' + WtColor.LineColor, borderRadius: "8px", padding: '2px 10px 2px 10px' }} >
                                                    {
                                                        (chName !== undefined && chWhatsApp !== undefined) ?
                                                            <>
                                                                <ListItemIcon><span className="text-white ps-1 pe-1 rounded-3" style={{ background: WtColor.TextLightGrey }}>{chName.charAt(0)}</span></ListItemIcon>
                                                                <ListItemText primary={chName} />
                                                                {channelSwitch ? <ExpandLess /> : <ExpandMore />}
                                                            </> :
                                                            <>
                                                                <ListItemIcon><span className="text-white ps-1 pe-1 rounded-3" style={{ background: WtColor.TextLightGrey }}>W</span></ListItemIcon>
                                                                <ListItemText primary="Channel" />
                                                                {channelSwitch ? <ExpandLess /> : <ExpandMore />}
                                                            </>
                                                    }
                                                </ListItemButton>
                                                <Collapse in={channelSwitch} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        {
                                                            channelLs.channelLs ? channelLs.channelLs?.map((v, i) => {
                                                                return (
                                                                    <ListItemButton onClick={() => setChInfo(v.title, v.whatsapp)} key={i}>
                                                                        <ListItemIcon><span className="text-white ps-1 pe-1 rounded-3" style={{ background: WtColor.TextLightGrey }}>{v.title.charAt(0)}</span></ListItemIcon>
                                                                        <ListItemText primary={v.title} />
                                                                    </ListItemButton>
                                                                )
                                                            }) :
                                                                <ListItemButton>
                                                                    <ListItemIcon><AddBoxOutlined /></ListItemIcon>
                                                                    <ListItemText primary="Add Channel" />
                                                                </ListItemButton>
                                                        }
                                                    </List>
                                                </Collapse>
                                            </List>
                                            <div>
                                                <button className="btn btn-sm" style={{ background: WtColor.BaseColor, color: '#fff', borderRadius: '8px', margin: '2px 0px 0px 6px', paddingBottom: '6px', paddingTop: '4px', paddingLeft: '10px', paddingRight: '12px' }} onClick={() => handleTemplateSync()}><Sync style={{ fontSize: '14px' }} /> Sync</button>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="template_ui_toggle">
                                            <ToggleButtonGroup orientation="horizontal" value={templateUIView.templateUIView} exclusive onChange={handleTemplateUIView}>
                                                <ToggleButton value="normal" aria-label="normal"><ViewList /></ToggleButton>
                                                <ToggleButton value="grid" aria-label="grid"><ViewModule /></ToggleButton>
                                            </ToggleButtonGroup>
                                        </div>
                                    </Col>
                                    <Col>
                                        <input onChange={(e) => searchItems(e.target.value)} type="search" className="w-100" style={{ flex: 1, fontSize: "16px", outlineWidth: "0px", borderRadius: "30px", height: "40px", paddingLeft: "20px", paddingRight: "20px" }} placeholder="Search Template" />
                                    </Col>
                                </Row>
                            </div>
                            <Row className="app_list" style={{ height: notificationBarStatus.notificationBarStatus ? '80vh' : '85vh' }}>
                                {
                                    searchLs?.filter((v) => { return v.status === "APPROVED" | v.status === "approved" })?.map((v, i) => {
                                        return (
                                            <>
                                                {
                                                    templateUIView.templateUIView === 'normal' &&
                                                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} key={i} className="mb-3">
                                                        <div>
                                                            <div>
                                                                <div style={chatBubbleNormal}>
                                                                    <div>
                                                                        <Tooltip title={v.name} placement='bottom'>
                                                                            <p className='text-center fw-bold' style={{ color: WtColor.TextMidGrey, fontSize: '13px' }}>{v.name?.substring(0, 25) + '...'}</p>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <TemplateMessageWithVariable templateComponent={v.components} />
                                                                </div>
                                                                <div className="chat_bubble_for_template">
                                                                    {
                                                                        v.components?.map((bv, bi) => {
                                                                            return (
                                                                                <div>
                                                                                    {
                                                                                        (() => {
                                                                                            if (bv.type && bv.type === "BUTTONS" && bv.buttons) { return <TemplateButtonMessageForMultiPurpose buttons={bv.buttons} key={bi} /> }
                                                                                        })()
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                }

                                                {
                                                    templateUIView.templateUIView === 'grid' &&
                                                    <Col xxl={2} xl={2} lg={2} md={2} sm={2} xs={2} key={i} className="mb-3">
                                                        <div>
                                                            <div>
                                                                <div style={chatBubbleGrid}>
                                                                    <div>
                                                                        <Tooltip title={v.name} placement='bottom'>
                                                                            <p className='text-center fw-bold' style={{ color: WtColor.TextMidGrey, fontSize: '13px' }}>{v.name?.substring(0, 25) + '...'}</p>
                                                                        </Tooltip>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                }
                                            </>
                                        )
                                    })
                                }
                                {/* {searchLs?.length === 0 && <div><p className="text-center" style={{ color: WtColor.TextMidGrey }}>Sorry! No such template found...</p></div>} */}
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>

            {isLoading.isLoading && <WtLoader open={isLoading.isLoading} />}
        </div >
    )
}
